import React from 'react';

import { DestinationOption } from '@lt/api/dist/methods/references/types';
import { PreviousSearchesOption } from '../../../../../context';
import { PreviousSearchOption } from './PreviousSearchOption';
import { PopularCountryOption } from './PopularCountryOption';
import { AllCountryOption } from './AllCountryOption';
import { Template } from './Template';

export const BodyOption = (data: DestinationOption | PreviousSearchesOption) => {
  switch (data.groupName) {
    case 'previousSearches':
      return <PreviousSearchOption {...data} />;
    case 'countries':
    case 'popularCountries':
      return <PopularCountryOption {...data} />;
    case 'allCountries':
      return <AllCountryOption {...data} />;
    case 'metaregions':
    case 'allMetaregions': {
      return <Template {...data}>{data.description}</Template>;
    }
    case 'hotels': {
      return (
        <Template {...data}>
          {data.cityName}
          {data.countryName && `, ${data.countryName}`}
        </Template>
      );
    }
    case 'regions': {
      return <Template {...data}>{data.activeRegions ?? data.countryName}</Template>;
    }
    default:
      return <Template {...data} />;
  }
};
